/**
 * Collection Quickadd Handler
 * 
 * This script handles the quickadd functionality on collection pages and featured product sections.
 * It provides responsive buttons that:
 * - Show "Add to Cart" for products with default variant only
 * - Show "Add [Option Label]" for products with multiple variants initially
 * - Open quickview modal for products with variants
 * - Handle quantity based on case sizes
 * - Manage sold-out states
 * - Show a "Notify me when back in stock" form when a selected variant's
 *   case-pack-aware stock (maxCases) is < 1 (added 2026-08-04)
 */

(function() {
  'use strict';

  // Quick runtime sanity logs to help debug why handlers might not run
  try {
    console.log('collection-quickadd-handler.js loaded');
    if (typeof window.jQuery === 'undefined' && typeof window.$ === 'undefined') {
      console.warn('collection-quickadd-handler: jQuery not detected. Event bindings may fail.');
    } else {
      console.log('collection-quickadd-handler: jQuery detected');
    }
  } catch (err) {
    // ignore console errors in odd runtimes
  }

  // Initialize the collection quickadd handler
  function initCollectionQuickaddHandler() {
    try {
      console.log('Initializing collection quickadd handler');
      
      // Remove any existing event handlers to prevent conflicts
      $(document).off('click.quickaddHandler', '.collection-add-to-bag-button');
      $(document).off('click.quickaddHandler', '.collection-add-to-cart-button');

      // Find all collection variant buttons
      const $variantButtons = $('.collection-variant-button');
      console.log(`Found ${$variantButtons.length} collection variant buttons`);

      // Find all collection add to bag buttons
      const $addToBagButtons = $('.collection-add-to-bag-button');
      console.log(`Found ${$addToBagButtons.length} collection add to bag buttons`);

      // Find all collection add to cart buttons
      const $addToCartButtons = $('.collection-add-to-cart-button');
      console.log(`Found ${$addToCartButtons.length} collection add to cart buttons`);

      // Find all variant option value buttons
      const $variantOptionValues = $('.variant-option-value');
      console.log(`Found ${$variantOptionValues.length} variant option value buttons`);

      // Log context information
      if ($('.product-recommendations').length) {
        console.log('Product recommendations section found');
      }
      if ($('.related-products').length) {
        console.log('Related products section found');
      }
      if ($('.slider-gallery').length) {
        console.log('Slider gallery found');
      }

      // Set up event listeners for quickadd functionality
      setupQuickaddEventListeners();

      // Set up event listeners for collection template buttons
      setupCollectionButtonEventListeners();

      // Initialize existing quickadd forms
      initializeExistingQuickaddForms();

      // Show the "Add to Cart" quantity/case-size for no-variant products immediately,
      // since updateVariantSelection() is never called for them.
      initializeNoVariantNotifyState();

      // Grey out sold-out swatches immediately, for any product whose variant
      // options are already visible on load rather than requiring a click first.
      markAllSwatchAvailabilityOnLoad();
    } catch (err) {
      console.error('initCollectionQuickaddHandler error', err);
    }
  }

  // Set up event listeners for quickadd functionality
  function setupQuickaddEventListeners() {
    // Handle quickadd button clicks
    $(document).on('click', '[data-quickadd-button]', function(e) {
      e.preventDefault();
      handleQuickaddButtonClick($(this));
    });

    // Handle variant swatch selection
    $(document).on('change', '[data-quickadd-swatch]', function() {
      handleVariantSwatchChange($(this));
    });

    // Handle variant swatch clicks (for radio buttons)
    $(document).on('click', '[data-quickadd-swatch]', function() {
      if ($(this).attr('type') === 'radio') {
        handleVariantSwatchChange($(this));
      }
    });
  }

  // Set up event listeners for collection template buttons
  function setupCollectionButtonEventListeners() {
    // Handle collection variant button clicks (shows variant options)
    $(document).on('click', '.collection-variant-button', function(e) {
      e.preventDefault();
      handleCollectionVariantButtonClick($(this));
      updateVariantSelection(productId);

    });

    // Handle collection add to bag button clicks (direct add to cart)
    // Use namespaced event to prevent conflicts with utilities.js
    $(document).off('click.quickaddHandler', '.collection-add-to-bag-button').on('click.quickaddHandler', '.collection-add-to-bag-button', function(e) {
      e.preventDefault();
      e.stopPropagation(); // Stop event from bubbling up
      handleCollectionAddToBagButtonClick($(this));
      return false; // Prevent default and stop propagation
    });

    // Handle collection add to cart button clicks (adds selected variant to cart)
    // Use namespaced event to prevent conflicts with utilities.js
    $(document).off('click.quickaddHandler', '.collection-add-to-cart-button').on('click.quickaddHandler', '.collection-add-to-cart-button', function(e) {
      e.preventDefault();
      e.stopPropagation(); // Stop event from bubbling up
      handleCollectionAddToCartButtonClick($(this));
      return false; // Prevent default and stop propagation
    });

    // Handle variant option value clicks
    $(document).on('click', '.variant-option-value', function(e) {
      e.preventDefault();
      handleVariantOptionValueClick($(this));
    });
  }

  // Handle collection variant button clicks (shows variant options)
  function handleCollectionVariantButtonClick($button) {
    const productId = $button.data('product-id');
    const $variantOptions = $(`.collection-variant-options[data-product-id="${productId}"]`);
    
    console.log('Showing variant options for product:', productId);
    
    // Show loading state
    $button.prop('disabled', true);
    $button.text('Loading...');
    
    // Hide the variant button
    $button.hide();
    
    // Show the variant options
    $variantOptions.show();
    // Store original product card image so we can restore it later
    try {
      const $productContainer = findProductContainer(productId);
      const $imgs = $productContainer.find('[data-product-image] img');
      const $primaryImg = $imgs.not('.secondary').first();
      const $secondaryImg = $imgs.filter('.secondary').first();

      if ($img.length && !$productContainer.data('original-image')) {
        const originalSrc = $img.attr('src') || $img.attr('data-src') || '';
        const originalDataSrc = $img.attr('data-src') || '';
        const originalSrcset = $img.attr('srcset') || '';
        const originalDataSrcset = $img.attr('data-srcset') || '';

        $productContainer.data('original-image', originalSrc);
        $productContainer.data('original-data-src', originalDataSrc);
        $productContainer.data('original-srcset', originalSrcset);
        $productContainer.data('original-data-srcset', originalDataSrcset);
      }
    } catch (err) {
      console.warn('Could not store original product image for', productId, err);
    }

    // Initialize the first variant as selected
    initializeVariantSelection(productId);
    
    // Re-enable button for future use
    $button.prop('disabled', false);
    const $parentButtoncontainer = $('.collection-button-container');
$parentButtoncontainer.each(function () {
  $(this).css('align-items', 'flex-end');
});
    $button.text('Select ' + $button.data('option-name'));
  }

  // Handle variant option value clicks
  function handleVariantOptionValueClick($optionValue) {
    const productId = $optionValue.data('product-id');
    const optionName = $optionValue.data('option-name');
    const optionValue = $optionValue.data('option-value');
    
    console.log('Variant option selected:', { productId, optionName, optionValue });
    
    // Update selected state for this option group
    const $optionGroup = $optionValue.closest('.variant-option-group');
    $optionGroup.find('.variant-option-value').removeClass('selected');
    $optionValue.addClass('selected');
    
    // Update variant selection and check if we can show add to cart button
    updateVariantSelection(productId);

    // If this option has a variant image attribute, update the card image immediately
    try {
      // Debugging: log attribute presence (both .attr and .data)
      const attrVariantImage = $optionValue.attr('data-variant-image');
      const dataVariantImage = $optionValue.data('variant-image');
      const attrVariantSrcset = $optionValue.attr('data-variant-srcset');
      const dataVariantSrcset = $optionValue.data('variant-srcset');
      console.log('variant attrs for clicked option:', {
        attrVariantImage,
        dataVariantImage,
        attrVariantSrcset,
        dataVariantSrcset,
        html: $optionValue.prop('outerHTML')
      });

      // Prefer attr/explicit string if present
      const variantSrcsetString = attrVariantSrcset || dataVariantSrcset;
      const variantImageString = attrVariantImage || dataVariantImage;

      if (variantSrcsetString) {
        const firstUrl = (variantSrcsetString.split(',')[0] || '').trim().split(' ')[0] || variantImageString;
        console.log('Calling updateProductCardImage with srcset firstUrl:', firstUrl, ' srcset:', variantSrcsetString);
        updateProductCardImage(productId, firstUrl, variantSrcsetString);
      } else if (variantImageString) {
        console.log('Calling updateProductCardImage with image:', variantImageString);
        updateProductCardImage(productId, variantImageString);
      } else {
        console.log('No variant image/srcset found on clicked option');
      }
    } catch (err) {
      console.warn('Error updating product card image on option click', err);
    }
  }

  // Initialize variant selection for a product
  function initializeVariantSelection(productId) {
    const $variantOptions = $(`.collection-variant-options[data-product-id="${productId}"]`);
    
    // Set first option as selected for each option group
    $variantOptions.find('.variant-option-group').each(function() {
      $(this).find('.variant-option-value').first().addClass('selected');
    });
    
    // Update variant selection
    updateVariantSelection(productId);

    // If any selected option has a variant image, use it for the card
    try {
      const $firstSelected = $variantOptions.find('.variant-option-value.selected[data-variant-image]').first();
      if ($firstSelected.length) {
        const img = $firstSelected.data('variant-image');
        if (img) updateProductCardImage(productId, img);
      }
    } catch (err) {
      console.warn('Error setting initial product card image for', productId, err);
    }
  }

  // Given a case size and a variant's raw inventory data, work out how many
  // full cases can actually be sold. Returns Infinity when Shopify isn't
  // tracking/blocking on inventory for this variant (nothing to enforce).
  function getMaxCasesAvailable(caseSize, inventoryQuantity, inventoryManagement, inventoryPolicy) {
    if (inventoryManagement !== 'shopify' || inventoryPolicy === 'continue') {
      return Infinity;
    }

    const qty = parseInt(inventoryQuantity, 10);
    const size = parseInt(caseSize, 10) || 1;

    if (isNaN(qty)) {
      return Infinity;
    }

    return Math.floor(qty / size);
  }

  // Show the "not enough stock" message above a product tile's buttons
  // NOTE (2026-08-04): disabled per request — the disabled "Out of Stock"
  // button already communicates this; the extra text line is no longer
  // wanted. Left as a no-op rather than deleting every call site, so this
  // is the single place to re-enable it later if needed.
  function showCollectionStockWarning(productId, stock, caseSize) {
    return;
  }

  // Clear the "not enough stock" message for a product tile
  function clearCollectionStockWarning(productId) {
    const $warning = $(`[data-collection-cart-warning="${productId}"]`);
    if (!$warning.length) return;

    $warning.text('').hide();
  }

  // Mark each swatch button as sold-out based on its own variant's maxCases.
  // No `disabled` attribute (matches retail — sold-out swatches stay
  // clickable) and no dependency on a CSS class, since we don't have write
  // access to the wholesale stylesheet from here. Greyout is applied as
  // inline styles directly so it actually renders regardless of what's (or
  // isn't) defined in CSS.
  function markSwatchAvailability(productId) {
    const $variantOptions = $(`.collection-variant-options[data-product-id="${productId}"]`);

    $variantOptions.find('.variant-option-value[data-variant-id]').each(function() {
      const $opt = $(this);
      const variantTitle = $opt.data('variant-title');
      const metafieldCaseSize = $opt.data('case-size');
      const inventoryQuantity = $opt.data('inventory-quantity');
      const inventoryManagement = $opt.data('inventory-management');
      const inventoryPolicy = $opt.data('inventory-policy');

      const caseSize = getVariantCaseSize(variantTitle, metafieldCaseSize);
      const maxCases = getMaxCasesAvailable(caseSize, inventoryQuantity, inventoryManagement, inventoryPolicy);
      const soldOut = maxCases < 1;

      $opt.toggleClass('sold-out', soldOut);

      if (soldOut) {
        $opt.css({
          opacity: '0.35',
          filter: 'grayscale(70%)'
        });
        $opt.find('.variant-option-image img').css('filter', 'grayscale(70%)');
      } else {
        $opt.css({
          opacity: '',
          filter: ''
        });
        $opt.find('.variant-option-image img').css('filter', '');
      }
    });
  }

  // Run markSwatchAvailability for every product's swatch set on page load,
  // not just after a "Select [Option]" click — a product's variant options
  // block can already be visible on load (e.g. via a saved state or a
  // section that expands it by default), and swatches should reflect
  // correct sold-out styling immediately rather than waiting on interaction.
  function markAllSwatchAvailabilityOnLoad() {
    $('.collection-variant-options').each(function() {
      const productId = $(this).data('product-id');
      if (productId) markSwatchAvailability(productId);
    });
  }

  // No-variant products (single default variant) don't go through
  // updateVariantSelection, so check their notify state once on load.
  function initializeNoVariantNotifyState() {
    $('.collection-add-to-bag-button').each(function() {
      const $button = $(this);
      const productId = $button.data('product-id');
      const variantTitle = $button.data('variant-title') || $button.attr('data-variant-title') || '';
      const metafieldCaseSize = $button.data('case-size') || $button.attr('data-case-size');
      const inventoryQuantity = $button.data('inventory-quantity');
      const inventoryManagement = $button.data('inventory-management');
      const inventoryPolicy = $button.data('inventory-policy');

      const caseSize = getVariantCaseSize(variantTitle, metafieldCaseSize);
      const maxCases = getMaxCasesAvailable(caseSize, inventoryQuantity, inventoryManagement, inventoryPolicy);

      if (maxCases < 1) {
        $button.text('Out of Stock');
        $button.prop('disabled', true);
        showCollectionStockWarning(productId, inventoryQuantity, caseSize);
      }
    });
  }

  // Update variant selection and show/hide add to cart button
  function updateVariantSelection(productId) {
    const $variantOptions = $(`.collection-variant-options[data-product-id="${productId}"]`);
    const $addToCartButton = $variantOptions.find('.collection-add-to-cart-button');
    
    // Check if all options have a selection
    const allOptionsSelected = $variantOptions.find('.variant-option-value.selected').length === $variantOptions.find('.variant-option-group').length;
    
    if (allOptionsSelected) {
      // Show add to cart button
      $addToCartButton.show();
      
      // Get selected variant ID and details
      const selectedVariantId = getSelectedVariantId(productId);
      if (selectedVariantId) {
      $addToCartButton.attr('data-variant-id', selectedVariantId);

      const variantDetails = getSelectedVariantDetails(productId);
      
      if (variantDetails) {
        const caseSize = variantDetails.caseSize || 1;
        const quantityText = caseSize > 1 ? ` (Qty: ${caseSize})` : '';

        if (variantDetails.maxCases < 1) {
          // Not enough stock for even one full case — block before the click happens
          $addToCartButton.prop('disabled', true);
          $addToCartButton.text('Out of Stock');
          showCollectionStockWarning(productId, variantDetails.inventoryQuantity, caseSize);
          console.warn('Not enough stock for a full case:', {
            productId,
            caseSize,
            inventoryQuantity: variantDetails.inventoryQuantity
          });
        } else {
          $addToCartButton.prop('disabled', false); // <-- clear stale disabled state
          $addToCartButton.text(`Add to Cart - ${variantDetails.price}`);
          clearCollectionStockWarning(productId);
        }
        
        showSelectedVariantInfo(productId, variantDetails);
        try {
          const $variantOptionsSelected = $variantOptions.find('.variant-option-value.selected');
          let foundImg = null;
          $variantOptionsSelected.each(function() {
            const $opt = $(this);
            const vId = $opt.data('variant-id');
            if (vId && String(vId) === String(selectedVariantId) && $opt.data('variant-image')) {
              foundImg = $opt.data('variant-image');
              return false;
            }
          });
          if (!foundImg) {
            const $anyImgOpt = $variantOptionsSelected.filter('[data-variant-image]').first();
            if ($anyImgOpt.length) foundImg = $anyImgOpt.data('variant-image');
          }
          if (foundImg) updateProductCardImage(productId, foundImg);
        } catch (err) {
          console.warn('Error updating card image after full variant selection', err);
        }
      }
    } else {
      $addToCartButton.text('Out of Stock');
      $addToCartButton.prop('disabled', true);
      console.error('Selected variant not found for product:', productId);
    }
    } else {
      // Hide add to cart button
      $addToCartButton.hide();
      clearCollectionStockWarning(productId);
    }

    // Refresh sold-out styling on the swatches themselves (CSS-only, no disabled attribute)
    markSwatchAvailability(productId);
  }

  // Get selected variant details
  function getSelectedVariantDetails(productId) {
    const $variantOptions = $(`.collection-variant-options[data-product-id="${productId}"]`);
    const selectedOptions = {};
    
    // Get all selected option values
    $variantOptions.find('.variant-option-value.selected').each(function() {
      const optionName = $(this).data('option-name');
      const optionValue = $(this).data('option-value');
      const optionprice = $(this).data('variant-price');
      selectedOptions[optionName] = optionValue;
    });
    
    // Find the selected variant option that has variant data
    let selectedVariant = null;
    $variantOptions.find('.variant-option-value.selected').each(function() {
      const $option = $(this);
      const variantId = $option.data('variant-id');
      const variantTitle = $option.data('variant-title');
      const variantPrice = $option.data('variant-price');
      const metafieldCaseSize = $option.data('case-size');
      const inventoryQuantity = $option.data('inventory-quantity');
      const inventoryManagement = $option.data('inventory-management');
      const inventoryPolicy = $option.data('inventory-policy');
      
      if (variantId && variantTitle) {
        // Calculate the actual case size using the same logic as product page
        const caseSize = getVariantCaseSize(variantTitle, metafieldCaseSize);
        const maxCases = getMaxCasesAvailable(caseSize, inventoryQuantity, inventoryManagement, inventoryPolicy);
        
        selectedVariant = {
          id: variantId,
          title: variantTitle,
          price: variantPrice,
          caseSize: caseSize,
          inventoryQuantity: inventoryQuantity,
          maxCases: maxCases
        };
        return false; // Break the loop
      }
    });
    
    return selectedVariant;
  }

  // Show selected variant information
  function showSelectedVariantInfo(productId, variantDetails) {
    const $variantOptions = $(`.collection-variant-options[data-product-id="${productId}"]`);
    const $selectedVariantInfo = $variantOptions.find('.selected-variant-info');
    const $selectedVariantTitle = $selectedVariantInfo.find('.selected-variant-title');
    const $selectedVariantPrice = $selectedVariantInfo.find('.selected-variant-price');
    
    if (variantDetails && variantDetails.title) {
      $selectedVariantTitle.text(variantDetails.title);
      $selectedVariantPrice.text(variantDetails.price || '');
      
      // Add quantity information
      const caseSize = variantDetails.caseSize || 1;
      if (caseSize > 1) {
        $selectedVariantPrice.append(` <small>(Qty: ${caseSize})</small>`);
      }
      
      $selectedVariantInfo.show();
    } else {
      $selectedVariantInfo.hide();
    }
  }

  // Get the case size for a variant based on title and metafields
  function getVariantCaseSize(variantTitle, metafieldCaseSize) {
    console.log('Extracting case size from:', { variantTitle, metafieldCaseSize });

    // FIX (2026-08-05): reverting the earlier "Assorted" keyword heuristic —
    // it wrongly assumed every "Assorted" title meant an Easify-tracked
    // bundle with case size 1 (true for "Dare to Bare | Hand Cream | CS 36
    // Assorted", where Easify counts whole bundles). It's false for
    // "Salt Bath | CS 12 Assorted", where "Assorted" just describes the mix
    // of scents inside a normal 12-unit case — case size is genuinely 12,
    // parsed correctly from the title. Guessing intent from that one word
    // isn't reliable in either direction.
    //
    // Correct priority instead: the wholesale.case_size metafield is the
    // merchant's explicit, per-product source of truth — trust it whenever
    // it's set, regardless of what the title says. Only fall back to
    // parsing "CS N" out of the title when the metafield is blank. This
    // also matches the case size logic already documented elsewhere in
    // this theme ("metafield with fallback to parsing title").
    const metafieldCaseSizeInt = parseInt(metafieldCaseSize, 10);
    if (!isNaN(metafieldCaseSizeInt) && metafieldCaseSizeInt >= 1) {
      console.log('Using case size from metafield (authoritative):', metafieldCaseSizeInt);
      return metafieldCaseSizeInt;
    }

    let caseSize = 1;
    
    // Check if variant title contains "CS " (case size) - e.g., "LG 3OZ |$10.50 EA/CS 6"
    if (variantTitle && variantTitle.toLowerCase().includes('cs ')) {
      const csMatch = variantTitle.toLowerCase().match(/cs\s+(\d+)/);
      if (csMatch && csMatch[1]) {
        caseSize = parseInt(csMatch[1], 10);
        console.log('Found case size from title "CS " pattern:', caseSize);
      }
    }
    
    // Also check for other common patterns like "CS-6", "CS6", "Case 6", etc.
    if (caseSize === 1 && variantTitle) {
      const patterns = [
        /cs-(\d+)/i,           // CS-6
        /cs(\d+)/i,            // CS6
        /case\s+(\d+)/i,       // Case 6
        /case-(\d+)/i,         // Case-6
        /(\d+)\s*cs/i,         // 6 CS
        /(\d+)\s*case/i        // 6 Case
      ];
      
      for (const pattern of patterns) {
        const match = variantTitle.match(pattern);
        if (match && match[1]) {
          caseSize = parseInt(match[1], 10);
          console.log(`Found case size from pattern ${pattern}:`, caseSize);
          break;
        }
      }
    }
    
    // If we found a case size from title, use it; otherwise check metafield
    if (caseSize === 1 && metafieldCaseSize) {
      const metafieldCaseSizeInt = parseInt(metafieldCaseSize, 10);
      if (!isNaN(metafieldCaseSizeInt) && metafieldCaseSizeInt > 1) {
        caseSize = metafieldCaseSizeInt;
        console.log('Found case size from metafield:', caseSize);
      }
    }
    
    console.log('Final case size determined:', caseSize);
    return caseSize;
  }

  // Get the selected variant ID based on current option selections
  function getSelectedVariantId(productId) {
    const $variantOptions = $(`.collection-variant-options[data-product-id="${productId}"]`);
    const selectedOptions = {};
    
    // Get all selected option values
    $variantOptions.find('.variant-option-value.selected').each(function() {
      const optionName = $(this).data('option-name');
      const optionValue = $(this).data('option-value');
      selectedOptions[optionName] = optionValue;
    });
    
    // Find the variant that matches all selected options
    // Use the new data attributes from the variant option buttons
    const $productContainer = findProductContainer(productId);
    
    if (!$productContainer.length) {
      console.error(`Product container not found for product ${productId}`);
      return null;
    }
    
    // Get all variants for this product
    const variants = [];
    $productContainer.find('.variant-option-value').each(function() {
      const $option = $(this);
      const variantId = $option.data('variant-id');
      const variantTitle = $option.data('variant-title');
      const variantPrice = $option.data('variant-price');
      const metafieldCaseSize = $option.data('case-size');
      
      if (variantId && variantTitle) {
        // Calculate the actual case size using the same logic as product page
        const caseSize = getVariantCaseSize(variantTitle, metafieldCaseSize);
        
        variants.push({
          id: variantId,
          title: variantTitle,
          price: variantPrice,
          caseSize: caseSize
        });
      }
    });
    
    // Find the variant that matches all selected options
    for (const variant of variants) {
      let matches = true;
      
      for (const optionName in selectedOptions) {
        const selectedOptionValue = selectedOptions[optionName];
        if (!variant.title.toLowerCase().includes(selectedOptionValue.toLowerCase())) {
          matches = false;
          break;
        }
      }
      
      if (matches) {
        return variant.id;
      }
    }
    
    return null;
  }

  // Reset variant selection and show original button
  function resetVariantSelection(productId) {
    const $variantOptions = $(`.collection-variant-options[data-product-id="${productId}"]`);
    const $variantButton = $(`.collection-variant-button[data-product-id="${productId}"]`);
    const $addToCartButton = $variantOptions.find('.collection-add-to-cart-button');
    const $selectedVariantInfo = $variantOptions.find('.selected-variant-info');
    
    // Hide variant options
    $variantOptions.hide();
    
    // Show original variant button
    $variantButton.show();
    
    // Hide add to cart button
    $addToCartButton.hide();
    
    // Hide selected variant info
    $selectedVariantInfo.hide();

    // Clear any stock warning shown for this product
    clearCollectionStockWarning(productId);
    
    // Reset selections
    $variantOptions.find('.variant-option-value').removeClass('selected');
    $variantOptions.find('.variant-option-group').each(function() {
      $(this).find('.variant-option-value').first().addClass('selected');
    });

    // Restore original product card image if we swapped it
    try {
      restoreProductCardImage(productId);
    } catch (err) {
      console.warn('Error restoring product card image for', productId, err);
    }
  }

  // Update the product card image for a given productId
function updateProductCardImage(productId, imageUrl, imageSrcset) {
  const $productContainer = findProductContainer(productId);
  if (!$productContainer.length) return;

  // Save originals once (so restoreProductCardImage works)
  if (!$productContainer.data('original-image-saved')) {
    const $firstImg = $productContainer.find('[data-product-image] img').first();
    if ($firstImg.length) {
      $productContainer.data('original-image', $firstImg.attr('src') || '');
      $productContainer.data('original-data-src', $firstImg.attr('data-src') || '');
      $productContainer.data('original-srcset', $firstImg.attr('srcset') || '');
      $productContainer.data('original-data-srcset', $firstImg.attr('data-srcset') || '');
      $productContainer.data('original-image-saved', true);
    }
  }

  const $imgs = $productContainer.find('[data-product-image] img');
  const $primaryImg = $imgs.not('.secondary').first();
  const $secondaryImg = $imgs.filter('.secondary').first();

  function setImg($img) {
    if (!$img || !$img.length) return;
    const el = $img.get(0);

    // Update src and data-src
    $img.attr('src', imageUrl);
    $img.attr('data-src', imageUrl);
    el.setAttribute('src', imageUrl);
    el.setAttribute('data-src', imageUrl);

    // Update srcset only if you have one
    if (imageSrcset) {
      $img.attr('srcset', imageSrcset);
      $img.attr('data-srcset', imageSrcset);
      el.setAttribute('srcset', imageSrcset);
      el.setAttribute('data-srcset', imageSrcset);
    }

    // Kick lazysizes if present
    try {
      if (window.lazySizes && window.lazySizes.loader && typeof window.lazySizes.loader.unveil === 'function') {
        window.lazySizes.loader.unveil(el);
      }
    } catch (e) {}
  }

  // Update both, so hover never shows the old original
  setImg($primaryImg);
  setImg($secondaryImg);
}



// Restore the original image saved on product container
function restoreProductCardImage(productId) {
  const $productContainer = findProductContainer(productId);
  if (!$productContainer.length) return;

  const originalSrc = $productContainer.data('original-image');
  const originalDataSrc = $productContainer.data('original-data-src');
  const originalSrcset = $productContainer.data('original-srcset');
  const originalDataSrcset = $productContainer.data('original-data-srcset');
  if (!originalSrc && !originalDataSrc && !originalSrcset && !originalDataSrcset) return;

  const $imgs = $productContainer.find('[data-product-image] img');
  const $primaryImg = $imgs.not('.secondary').first();
  const $secondaryImg = $imgs.filter('.secondary').first();

  function restoreImg($img) {
    if (!$img || !$img.length) return;
    if (originalDataSrc) $img.attr('data-src', originalDataSrc);
    if (originalDataSrcset) $img.attr('data-srcset', originalDataSrcset);
    if (originalSrcset) $img.attr('srcset', originalSrcset);
    if (originalSrc) $img.attr('src', originalSrc);

    const el = $img.get(0);
    try {
      if (el) {
        if (originalDataSrc) el.setAttribute('data-src', originalDataSrc);
        if (originalDataSrcset) el.setAttribute('data-srcset', originalDataSrcset);
        if (originalSrcset) el.setAttribute('srcset', originalSrcset);
        if (originalSrc) el.setAttribute('src', originalSrc);
      }
      if (window.lazySizes && window.lazySizes.loader && typeof window.lazySizes.loader.unveil === 'function') {
        window.lazySizes.loader.unveil(el);
      }
    } catch (e) {}
  }

  restoreImg($primaryImg);
  restoreImg($secondaryImg);

  // Clear stored data
  $productContainer.removeData('original-image');
  $productContainer.removeData('original-data-src');
  $productContainer.removeData('original-srcset');
  $productContainer.removeData('original-data-srcset');
  $productContainer.removeData('original-image-saved');
}


  // Handle collection add to cart button clicks (adds selected variant to cart)
  function handleCollectionAddToCartButtonClick($button) {
    const productId = $button.data('product-id');
    
    // Get the current selected variant ID from the DOM (not from button data which may be stale)
    const variantId = getSelectedVariantId(productId);
    
    if (!variantId) {
      console.error('No variant ID found for product:', productId);
      return;
    }
    
    console.log('Adding selected variant to cart:', { productId, variantId });
    
    // Get the case size for this variant - always get fresh data from currently selected options
    let caseSize = 1;
    let maxCases = Infinity;
    let inventoryQuantity = null;
    
    // Get fresh variant details from currently selected options
    const variantDetails = getSelectedVariantDetails(productId);
    if (variantDetails && variantDetails.caseSize) {
      caseSize = variantDetails.caseSize;
      maxCases = variantDetails.maxCases;
      inventoryQuantity = variantDetails.inventoryQuantity;
      console.log('Using case size from selected variant details:', caseSize, 'maxCases:', maxCases);
    } else {
      // Fallback: try to get from the specific selected option for this variant
      const $variantOptions = $(`.collection-variant-options[data-product-id="${productId}"]`);
      const $selectedOption = $variantOptions.find('.variant-option-value.selected[data-variant-id="' + variantId + '"]');
      
      if ($selectedOption.length) {
        const variantTitle = $selectedOption.data('variant-title') || $selectedOption.attr('data-variant-title');
        const metafieldCaseSize = $selectedOption.data('case-size') || $selectedOption.attr('data-case-size');
        const optInventoryQuantity = $selectedOption.data('inventory-quantity');
        const inventoryManagement = $selectedOption.data('inventory-management');
        const inventoryPolicy = $selectedOption.data('inventory-policy');
        console.log('Selected option data for case size calculation:', { variantTitle, metafieldCaseSize });
        caseSize = getVariantCaseSize(variantTitle, metafieldCaseSize);
        maxCases = getMaxCasesAvailable(caseSize, optInventoryQuantity, inventoryManagement, inventoryPolicy);
        inventoryQuantity = optInventoryQuantity;
      } else {
        console.warn('No selected option found for variant ID:', variantId, 'using default case size 1');
      }
    }

    // Hard stop: never call /cart/add.js for less than a full case's worth of stock.
    // Shopify would otherwise silently clamp the quantity down instead of rejecting it.
    if (maxCases < 1) {
      console.warn('Blocked add-to-cart: not enough stock for a full case.', { productId, variantId, caseSize });
      $button.text('Out of Stock');
      $button.prop('disabled', true);
      showCollectionStockWarning(productId, inventoryQuantity, caseSize);
      return;
    }
    
    console.log('Final calculated case size for add to cart:', caseSize);

    // Show loading state
    const originalText = $button.text();
    $button.prop('disabled', true);
    $button.text('Adding...');
    
    // Prepare cart data
    const cartData = {
      id: variantId,
      quantity: parseInt(caseSize) || 1
    };
    
    // Add to cart using Shopify AJAX API
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: cartData,
      dataType: 'json',
      success: function(response) {
        console.log('Successfully added to cart:', response);

        clearCollectionStockWarning(productId);
        
        // Update cart count and show cart drawer if available
        if (window.PXUTheme && window.PXUTheme.jsAjaxCart) {
          window.PXUTheme.jsAjaxCart.updateView();
          window.PXUTheme.jsAjaxCart.showDrawer();
        } else if (window.Shopify && window.Shopify.theme && window.Shopify.theme.jsAjaxCart) {
          window.Shopify.theme.jsAjaxCart.updateView();
          if (window.Shopify.theme.jsAjaxCart.showDrawer) {
            window.Shopify.theme.jsAjaxCart.showDrawer();
          }
        }
        
        // Show success feedback - this function will handle resetting the button
        showCollectionButtonSuccess($button, originalText);
      },
      error: function(xhr, status, error) {
        console.error('Error adding to cart:', error);
        
        // Show error feedback and reset button after error
        showCollectionButtonError($button, originalText, xhr.responseJSON?.description || 'Error adding to cart');
      }
    });
  }

  // Handle collection add to bag button clicks (direct add to cart)
  function handleCollectionAddToBagButtonClick($button) {
    const productId = $button.data('product-id');
    const variantId = $button.data('variant-id');
    
    console.log('Adding product directly to cart:', { productId, variantId });
    
    // Get the case size for this variant - always get fresh data from button attributes
    let caseSize = 1;
    
    // Get the variant title and case size directly from the clicked button
    const variantTitle = $button.data('variant-title') || $button.attr('data-variant-title') || '';
    const metafieldCaseSize = $button.data('case-size') || $button.attr('data-case-size');
    const inventoryQuantity = $button.data('inventory-quantity');
    const inventoryManagement = $button.data('inventory-management');
    const inventoryPolicy = $button.data('inventory-policy');
    
    console.log('Button data for case size calculation:', { variantTitle, metafieldCaseSize });
    
    // Calculate case size using the variant title and metafield data
    if (variantTitle) {
      caseSize = getVariantCaseSize(variantTitle, metafieldCaseSize);
    } else {
      // Fallback: use metafield case size if no variant title
      const metafieldCaseSizeInt = parseInt(metafieldCaseSize, 10);
      if (!isNaN(metafieldCaseSizeInt) && metafieldCaseSizeInt > 1) {
        caseSize = metafieldCaseSizeInt;
      }
    }

    const maxCases = getMaxCasesAvailable(caseSize, inventoryQuantity, inventoryManagement, inventoryPolicy);

    // Hard stop: never call /cart/add.js for less than a full case's worth of stock.
    if (maxCases < 1) {
      console.warn('Blocked add-to-cart: not enough stock for a full case.', { productId, variantId, caseSize, inventoryQuantity });
      $button.text('Out of Stock');
      $button.prop('disabled', true);
      showCollectionStockWarning(productId, inventoryQuantity, caseSize);
      return;
    }
    
    console.log('Final calculated case size for add to bag:', caseSize);

    // Show loading state
    const originalText = $button.text();
    $button.prop('disabled', true);
    $button.text('Adding...');
    
    // Prepare cart data
    const cartData = {
      id: variantId,
      quantity: parseInt(caseSize) || 1
    };
    
    // Add to cart using Shopify AJAX API
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: cartData,
      dataType: 'json',
      success: function(response) {
        console.log('Successfully added to cart:', response);

        clearCollectionStockWarning(productId);
        
        // Update cart count and show cart drawer if available
        if (window.PXUTheme && window.PXUTheme.jsAjaxCart) {
          window.PXUTheme.jsAjaxCart.updateView();
          window.PXUTheme.jsAjaxCart.showDrawer();
        } else if (window.Shopify && window.Shopify.theme && window.Shopify.theme.jsAjaxCart) {
          window.Shopify.theme.jsAjaxCart.updateView();
          if (window.Shopify.theme.jsAjaxCart.showDrawer) {
            window.Shopify.theme.jsAjaxCart.showDrawer();
          }
        }
        
        // Show success feedback - this function will handle resetting the button
        showCollectionButtonSuccess($button, originalText);
      },
      error: function(xhr, status, error) {
        console.error('Error adding to cart:', error);
        
        // Show error feedback and reset button after error
        showCollectionButtonError($button, originalText, xhr.responseJSON?.description || 'Error adding to cart');
      }
    });
  }

  // Show success feedback for collection buttons
  function showCollectionButtonSuccess($button, originalText) {
    $button.removeClass('error').addClass('success');
    $button.text('Added!');
    
    // Reset button after success
    setTimeout(() => {
      $button.removeClass('success');
      $button.prop('disabled', false);
      $button.text(originalText);
    }, 2000);
  }

  // Show error feedback for collection buttons
  function showCollectionButtonError($button, originalText, errorMessage) {
    $button.removeClass('success').addClass('error');
    $button.text(errorMessage);
    
    // Reset button after error
    setTimeout(() => {
      $button.removeClass('error');
      $button.prop('disabled', false);
      $button.text(originalText);
    }, 3000);
  }

  // Initialize existing quickadd forms on the page
  function initializeExistingQuickaddForms() {
    $('[data-quickadd]').each(function() {
      initializeQuickaddForm($(this));
    });
  }

  // Initialize a single quickadd form
  function initializeQuickaddForm($form) {
    const productId = $form.data('quickadd');
    const $button = $form.find('[data-quickadd-button]');
    const $variantTitle = $form.find('[data-quickadd-variant-title]');
    const $swatches = $form.find('[data-quickadd-swatches]');
    
    // For products with variants, initially hide swatches and show "Select [Option]" button
    if ($swatches.length && $swatches.children().length > 1) {
      $swatches.hide();
      $variantTitle.hide();
      
      // Set initial variant selection
      const firstVariant = $swatches.find('[data-quickadd-swatch]').first();
      if (firstVariant.length) {
        const variantId = firstVariant.val();
        const variantPrice = firstVariant.data('price');
        const variantTitle = firstVariant.data('title');
        
        // Update form with first variant
        updateQuickaddForm($form, variantId, variantPrice, variantTitle);
      }
      
      // Show "Select [Option]" button initially
      $button.addClass('selecting-variant');
      const firstOption = firstVariant.data('title');
      const firstPrice = firstVariant.data('price');
      $button.attr('data-label', `Select ${firstOption} ${firstPrice}`);
      $button.find('span').text(`Select ${firstOption} ${firstPrice}`);
    } else {
      // Product has no variants - show "Add to Bag" with product price
      const productPrice = $form.data('initial-price');
      $button.removeClass('selecting-variant');
      $button.attr('data-label', `Add to Cart ${productPrice}`);
      $button.find('span').text(`Add to Cart ${productPrice}`);
    }

    // Update button state based on current selection
    updateQuickaddButton($form);
  }

  // Handle quickadd button clicks
  function handleQuickaddButtonClick($button) {
    const $form = $button.closest('[data-quickadd]');
    const productId = $form.data('quickadd');
    
    // Check if this is a variant selection or add to cart action
    if ($button.hasClass('selecting-variant')) {
      // Show variant selection
      showVariantSelection($form);
    } else {
      // Add to cart
      addToCart($form);
    }
  }

  // Show variant selection interface
  function showVariantSelection($form) {
    const $swatches = $form.find('[data-quickadd-swatches]');
    const $variantTitle = $form.find('[data-quickadd-variant-title]');
    
    if ($swatches.length) {
      $swatches.addClass('show').show();
      $variantTitle.show();
      
      // Update button to show "Add to Bag" once variants are visible
      const $button = $form.find('[data-quickadd-button]');
      const selectedVariantId = $form.find('input[name="id"]:checked').val() || $form.find('input[name="id"]').val();
      const selectedVariant = $form.find(`input[value="${selectedVariantId}"]`);
      
      if (selectedVariant.length && selectedVariant.data('price')) {
        const variantPrice = selectedVariant.data('price');
        $button.removeClass('selecting-variant');
        $button.attr('data-label', `Add to Cart ${variantPrice}`);
        $button.find('span').text(`Add to Cart ${variantPrice}`);
      }
    }
  }

  // Handle variant swatch changes
  function handleVariantSwatchChange($swatch) {
    const $form = $swatch.closest('[data-quickadd]');
    const variantId = $swatch.val();
    const variantPrice = $swatch.data('price');
    const variantTitle = $swatch.data('title');
    const variantImage = $swatch.data('image');
    
    // Update form with selected variant
    updateQuickaddForm($form, variantId, variantPrice, variantTitle, variantImage);
    
    // Update button state
    updateQuickaddButton($form);
  }

  // Update quickadd form with selected variant
  function updateQuickaddForm($form, variantId, variantPrice, variantTitle, variantImage) {
    // Update hidden inputs
    $form.find('input[name="id"]').val(variantId);
    $form.find('input[data-quickadd-swatch]').prop('checked', false);
    $form.find(`input[value="${variantId}"]`).prop('checked', true);
    
    // Update variant title display
    const $variantTitle = $form.find('[data-quickadd-variant-title]');
    if ($variantTitle.length) {
      $variantTitle.text(variantTitle);
    }
    
    // Update quantity based on variant case size
    updateQuickaddQuantity($form, variantTitle);
    
    // Update form data attributes
    $form.attr('data-selected-variant', variantId);
    $form.attr('data-selected-price', variantPrice);
  }

  // Update quantity based on variant case size
  function updateQuickaddQuantity($form, variantTitle) {
    let qtyStep = 1;
    
    // Check if variant title contains "CS " (case size)
    if (variantTitle && variantTitle.toLowerCase().includes('cs ')) {
      const csMatch = variantTitle.toLowerCase().match(/cs\s+(\d+)/);
      if (csMatch && csMatch[1]) {
        qtyStep = parseInt(csMatch[1], 10);
        console.log('Found case size from title:', qtyStep);
      }
    }
    
    // If we still don't have a step value, try to get it from the selected swatch's data attribute
    if (qtyStep === 1) {
      const selectedVariantId = $form.find('input[name="id"]:checked').val() || $form.find('input[name="id"]').val();
      const selectedSwatch = $form.find(`input[value="${selectedVariantId}"]`);
      
      if (selectedSwatch.length && selectedSwatch.data('case-size')) {
        const caseSize = parseInt(selectedSwatch.data('case-size'), 10);
        if (!isNaN(caseSize) && caseSize > 1) {
          qtyStep = caseSize;
          console.log('Found case size from data attribute:', qtyStep);
        }
      }
    }
    
    // Update quantity input
    const $quantityInput = $form.find('input[name="quantity"]');
    if ($quantityInput.length) {
      $quantityInput.val(qtyStep);
    }
  }

  // Update quickadd button state
  function updateQuickaddButton($form) {
    const $button = $form.find('[data-quickadd-button]');
    const $swatches = $form.find('[data-quickadd-swatches]');
    const $variantTitle = $form.find('[data-quickadd-variant-title]');
    const productId = $form.data('quickadd');
    
    // Check if product has variants
    if ($swatches.length && $swatches.children().length > 1) {
      // Product has variants - check if variants are visible
      if ($swatches.is(':visible')) {
        // Variants are visible - show "Add to Cart" with selected variant price
        const selectedVariantId = $form.find('input[name="id"]:checked').val() || $form.find('input[name="id"]').val();
        const selectedVariant = $form.find(`input[value="${selectedVariantId}"]`);
        
        if (selectedVariant.length && selectedVariant.data('price')) {
          const variantPrice = selectedVariant.data('price');
          const variantTitle = selectedVariant.data('title');
          
          $button.removeClass('selecting-variant');
          $button.attr('data-label', `Add to Cart ${variantPrice}`);
          $button.find('span').text(`Add to Cart ${variantPrice}`);
          
          // Update form data
          $form.attr('data-selected-variant', selectedVariantId);
          $form.attr('data-selected-price', variantPrice);
        }
      } else {
        // Variants are hidden - show "Select [Option]" button
        const firstOption = $form.find('[data-quickadd-swatch]').first().data('title');
        const firstPrice = $form.find('[data-quickadd-swatch]').first().data('price');
        
        $button.addClass('selecting-variant');
        $button.attr('data-label', `Select ${firstOption} ${firstPrice}`);
        $button.find('span').text(`Select ${firstOption} ${firstPrice}`);
      }
    } else {
      // Product has no variants - show "Add to Cart" with product price
      const productPrice = $form.data('initial-price');
      
      $button.removeClass('selecting-variant');
      $button.attr('data-label', `Add to Cart ${productPrice}`);
      $button.find('span').text(`Add to Cart ${productPrice}`);
    }
  }

  // Add selected product to cart
  function addToCart($form) {
    const productId = $form.data('quickadd');
    const variantId = $form.find('input[name="id"]:checked').val() || $form.find('input[name="id"]').val();
    const quantity = parseInt($form.find('input[name="quantity"]').val()) || 1;
    
    if (!variantId) {
      console.warn('No variant selected for product:', productId);
      return;
    }
    
    console.log('Adding to cart:', { productId, variantId, quantity });
    
    // Show loading state
    const $button = $form.find('[data-quickadd-button]');
    const originalText = $button.find('span').text();
    $button.prop('disabled', true);
    $button.find('span').text('Adding...');
    
    // Prepare cart data
    const cartData = {
      id: variantId,
      quantity: quantity
    };
    
    // Add to cart using Shopify AJAX API
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: cartData,
      dataType: 'json',
      success: function(response) {
        console.log('Successfully added to cart:', response);
        
        // Update cart count if available
        if (window.PXUTheme && window.PXUTheme.jsAjaxCart) {
          window.PXUTheme.jsAjaxCart.updateView();
        } else if (window.Shopify && window.Shopify.theme && window.Shopify.theme.jsAjaxCart) {
          window.Shopify.theme.jsAjaxCart.updateView();
        }
        
        // Show success feedback
        showQuickaddSuccess($button, originalText);
        
        // Reset form to initial state
        setTimeout(() => {
          resetQuickaddForm($form);
        }, 2000);
      },
      error: function(xhr, status, error) {
        console.error('Error adding to cart:', error);
        
        // Show error feedback
        showQuickaddError($button, originalText, xhr.responseJSON?.description || 'Error adding to cart');
        
        // Reset button after error
        setTimeout(() => {
          $button.prop('disabled', false);
          $button.find('span').text(originalText);
        }, 3000);
      }
    });
  }

  // Show success feedback
  function showQuickaddSuccess($button, originalText) {
    $button.removeClass('error').addClass('success');
    $button.find('span').text('Added!');
    
    // Reset button after success
    setTimeout(() => {
      $button.removeClass('success');
      $button.prop('disabled', false);
      $button.find('span').text(originalText);
      console.log('this one',originalText);
    }, 2000);
  }

  // Show error feedback
  function showQuickaddError($button, originalText, errorMessage) {
    $button.removeClass('success').addClass('error');
    $button.find('span').text(errorMessage);
  }

  // Reset quickadd form to initial state
  function resetQuickaddForm($form) {
    // Reset variant selection
    $form.find('input[name="id"]').prop('checked', false);
    $form.find('input[name="id"]').first().prop('checked', true);
    
    // Reset quantity to default
    const $quantityInput = $form.find('input[name="quantity"]');
    if ($quantityInput.length) {
      $quantityInput.val(1);
    }
    
    // Hide variant selection
    const $swatches = $form.find('[data-quickadd-swatches]');
    const $variantTitle = $form.find('[data-quickadd-variant-title]');
    if ($swatches.length) {
      $swatches.removeClass('show').hide();
      $variantTitle.hide();
    }
    
    // Update button state
    updateQuickaddButton($form);
  }



  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionQuickaddHandler);
  } else {
    initCollectionQuickaddHandler();
  }

  // Also initialize when the page is loaded (for dynamic content)
  window.addEventListener('load', initCollectionQuickaddHandler);

  // Initialize when slider content changes (for featured collection slider)
  $(document).on('slider:ready slider:change', function() {
    console.log('Slider event detected, reinitializing collection quickadd handler');
    setTimeout(initCollectionQuickaddHandler, 100);
  });

  // Initialize when product recommendations are loaded
  $(document).on('recommendations:loaded', function() {
    console.log('Product recommendations loaded, initializing collection quickadd handler');
    setTimeout(initCollectionQuickaddHandler, 100);
  });

  // Also listen for AJAX completion in recommendations
  $(document).ajaxComplete(function(event, xhr, settings) {
    if (settings.url && settings.url.includes('recommendations')) {
      console.log('Product recommendations AJAX completed, initializing collection quickadd handler');
      setTimeout(initCollectionQuickaddHandler, 100);
    }
  });

  // Check if product has meaningful variants (not just different prices)
  function hasMeaningfulVariants(productId) {
    const $productContainer = findProductContainer(productId);
    const $variantSwatches = $productContainer.find('[data-quickadd-swatch]');
    
    if ($variantSwatches.length <= 1) {
      return false;
    }
    
    // Check if variants have different titles (not just different prices)
    const variantTitles = [];
    $variantSwatches.each(function() {
      const title = $(this).data('title');
      if (title && !variantTitles.includes(title)) {
        variantTitles.push(title);
      }
    });
    
    return variantTitles.length > 1;
  }

  // Enhanced product finding for both grid and slider views
  function findProductContainer(productId) {
    // Try multiple selectors to find the product container
    let $productContainer = $(`.product-${productId}`);
    
    if (!$productContainer.length) {
      // Try finding in slider view
      $productContainer = $(`.gallery-cell[data-product-id="${productId}"]`);
    }
    
    if (!$productContainer.length) {
      // Try finding by variant button
      $productContainer = $(`.collection-variant-button[data-product-id="${productId}"]`).closest('.gallery-cell, .product-wrap, .thumbnail');
    }
    
    if (!$productContainer.length) {
      // Try finding in any container with the product ID
      $productContainer = $(`[data-product-id="${productId}"]`).closest('.gallery-cell, .product-wrap, .thumbnail, .collection-button-container').parent();
    }
    
    if (!$productContainer.length) {
      // Try finding in product recommendations context
      $productContainer = $(`.product-recommendations .collection-variant-button[data-product-id="${productId}"]`).closest('.gallery-cell, .product-wrap, .thumbnail');
    }
    
    if (!$productContainer.length) {
      // Try finding in related products context
      $productContainer = $(`.related-products .collection-variant-button[data-product-id="${productId}"]`).closest('.gallery-cell, .product-wrap, .thumbnail');
    }
    
    console.log(`Finding product container for ${productId}:`, $productContainer.length ? 'Found' : 'Not found');
    return $productContainer;
  }

  // Make the function available globally for manual calls if needed
  window.PXUTheme = window.PXUTheme || {};
  window.PXUTheme.collectionQuickaddHandler = {
    init: initCollectionQuickaddHandler,
    updateQuickaddButton: updateQuickaddButton,
    addToCart: addToCart,
    hasMeaningfulVariants: hasMeaningfulVariants,
    findProductContainer: findProductContainer
  };

})();